import React, { Component } from 'react';
import { Container, Row, Button, Col } from 'react-bootstrap';

export default class ProjEditIntervalDom extends React.Component {
    constructor(props) {
        super(props);

        // this.state = {
        //     value: props.value
        // };
        this.onChangeYear = this.onChangeYear.bind(this);
        this.onChangeMonth = this.onChangeMonth.bind(this);
        this.onChangeDay = this.onChangeDay.bind(this);
    }

    onChangeYear(event) {
        console.log(event.target.value);
        this.props.onChange("interval_year", event.target.value);
    }
    onChangeMonth(event) {
        console.log(event.target.value);
        this.props.onChange("interval_month", event.target.value);
    }
    onChangeDay(event) {
        console.log(event.target.value);
        this.props.onChange("interval_day", event.target.value);
    }

    render() {
        const { isDisabled, data, year, month, day } = this.props;

        if (isDisabled) {
            return (
                <Col className="mb-2">
                    <label>{data.name}</label>
                    <div className="form-row">
                        <div className="col-3">
                            <input disabled type="number" className="form-control" placeholder="年" value={year} />
                        </div>
                        <div className="col-1">年</div>
                        <div className="col-3">
                            <input disabled type="number" className="form-control" placeholder="月" value={month} />
                        </div>
                        <div className="col-1">月</div>
                        <div className="col-3">
                            <input disabled type="number" className="form-control" placeholder="日" value={day} />
                        </div>
                        <div className="col-1">日</div>
                    </div>
                </Col>
            );
        } else {
            return (
                // <div className="col-sm-6">
                //     <label>{data.name}</label>
                //     <input className="form-control" type="text" value={value} onChange={this.onChange} />
                // </div>


                <Col className="mb-2">
                    <label>{data.name}</label>
                    <div className="form-row">
                        <div className="col-3">
                            <input type="number" className="form-control" placeholder="年" value={year} onChange={this.onChangeYear} />
                        </div>
                        <div className="col-1">年</div>
                        <div className="col-3">
                            <input type="number" className="form-control" placeholder="月" value={month} onChange={this.onChangeMonth} />
                        </div>
                        <div className="col-1">月</div>
                        <div className="col-3">
                            <input type="number" className="form-control" placeholder="日" value={day} onChange={this.onChangeDay} />
                        </div>
                        <div className="col-1">日</div>
                    </div>
                </Col>
            );
        }
    }
}